import {
    LEVEL_PROGRESS_GREEN_COLOR,
    LEVEL_PROGRESS_LIGHT_GREEN_COLOR,
} from '@utils';

const generateColor = (complete: number) => {
    if (complete < 70) {
        return LEVEL_PROGRESS_LIGHT_GREEN_COLOR;
    } else if (complete <= 100) {
        return LEVEL_PROGRESS_GREEN_COLOR;
    }
    return LEVEL_PROGRESS_LIGHT_GREEN_COLOR;
};
export default generateColor;
